import { Block, useStyletron } from "@mezo-org/mezo-clay"

import confettiBackground from "#/assets/confetti.png"
import { separateThousandsWithComaRegExp } from "#/shared/utils"

import SuccessfulActionModalBody from "../SuccessfulActionModalBody"

export default function RewardsClaimedBody({
  nextStepButtonLabel = "Done",
  totalMats,
  onClose,
}: {
  nextStepButtonLabel?: string
  totalMats: string
  onClose: () => void
}) {
  const [css] = useStyletron()
  return (
    // TODO: We can try to implement `override` pattern for the
    // `SuccessfulActionModalBody` so we can change the `title` component w/o
    // creating the component.
    <Block
      style={{
        height: "100%",
        marginLeft: "0",
        marginRight: "0",
        display: "flex",
        flexDirection: "column",
        background: confettiBackground,
      }}
    >
      <Block
        as="img"
        src={confettiBackground}
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        className={css({ objectFit: "cover", zIndex: -1 })}
      />
      <SuccessfulActionModalBody
        onClickContinue={onClose}
        title="Reward claimed"
        description={`${separateThousandsWithComaRegExp(totalMats)} mats`}
        nextStepButtonLabel={nextStepButtonLabel}
      />
    </Block>
  )
}
